import { subscriptionRequired } from '../stores/authStore';

let installed = false;

export function installFetchInterceptor() {
  if (installed) return;
  installed = true;

  const originalFetch = window.fetch;

  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);

    if (response.status === 403) {
      try {
        const cloned = response.clone();
        const body = await cloned.json();
        if (body.code === 'SUBSCRIPTION_REQUIRED') {
          subscriptionRequired.set(true);
        }
      } catch {
        // Ignore JSON parse errors
      }
    }

    return response;
  };
}
